// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__d0-9r","header":"MergedInvoice_header__3h9Pi"};